module.exports = __webpack_public_path__ + "static/media/markerRed.fc55d8b6.svg";